import classNames from 'classnames'
import React from 'react'

import { Collapse } from '@src/quince-components/src/atoms/collapse'

import { FilterItem } from '../menu/filterSection.interface'
import desktopStyles from '../menu/filterSectionWithDrawer/filterSectionWithDrawer.module.scss'
import { toTitleCase, hasSelectedValues, getSelectedCount } from '../menu/filterUtils'
import mobileStyles from '../menu/mobileFilters/mobileFilters.module.scss'

interface FilterCollapseGroupProps {
  filters: FilterItem[]
  selectedFiltersState: Record<string, string[]>
  activeItems?: string[]
  onChange?: (activeKeys: string[]) => void
  renderFilterComponent: (filter: FilterItem, isDrawer: boolean) => React.ReactNode
  isMobile?: boolean
  className?: string
}

export const FilterCollapseGroup: React.FC<FilterCollapseGroupProps> = ({
  filters,
  selectedFiltersState,
  activeItems,
  onChange,
  renderFilterComponent,
  isMobile = true,
  className,
}) => {
  // Select styles based on viewport
  const styles = isMobile ? mobileStyles : desktopStyles

  return (
    <Collapse
      className={classNames(styles.filterCollapseContainer, className)}
      resetOnUnmount={false}
      activeItems={activeItems}
      onChange={onChange}
    >
      {filters.map(filter => (
        <Collapse.Item
          key={`collapse-${filter.name}`}
          itemKey={filter.name}
          label={
            <>
              {toTitleCase(filter.config.label)}
              {hasSelectedValues(filter, selectedFiltersState) && (
                <span className={styles.filterCollapseCount}> ({getSelectedCount(filter, selectedFiltersState)})</span>
              )}
            </>
          }
          className={styles.filterCollapseItem}
          headerClassName={classNames(
            styles.filterCollapseHeader,
            hasSelectedValues(filter, selectedFiltersState) && styles.filterCollapseHeaderActive,
          )}
          contentClassName={styles.filterCollapseContent}
        >
          <div className={styles.filterCollapseBody}>{renderFilterComponent(filter, true)}</div>
        </Collapse.Item>
      ))}
    </Collapse>
  )
}
